<div
  class="progress-bar"
  *ngIf="!uploadFile.isError"
  [ngStyle]="{
    background:
      'linear-gradient(to right, #2dbbfc ' +
      uploadFile.progress * 100 +
      '% , #a2e0fd ' +
      uploadFile.progress * 100 +
      '%)',
  }"
>
  {{ formatPercentage() }}
</div>
<icn-close-btn *ngIf="canRemove" (remove)="onRemove()"></icn-close-btn>
<div class="fail" *ngIf="uploadFile.isError" (click)="uploadFile.retry()">
  <i inlineSVG="/assets/fail-icon-thum.svg"></i>
  <div>RETRY</div>
</div>
